
<script>
  import {onMount,createEventDispatcher} from 'svelte'
  import {fade} from 'svelte/transition'
 
  import {shareUrl,preload} from './../common.js'

  export let lang ="en";
  export let labels;
  export let userapp;
  const dispatch = createEventDispatcher();
  let install = true;
  let showModal = false;
  let samsungBrowser = navigator.userAgent.match(/SamsungBrowser/i);
  let browser = navigator.userAgent.match(/Chrome/i)
  let installPrompt;
  let iconLoaded = false;
  const iconImage = userapp.files+"/apple-touch-icon-precomposed.png?v="+userapp.version;

onMount(()=>{
  console.log(userapp)
 })

  
 
</script>

  <div id="android">
    <div id="a2handroid" class="a2h">
      <div style="height:95px">
      <div id="icon-container">
        
          <img
            id="iconimg"
            src="{iconImage}"
            alt="icon" 
            class:iconLoaded
            on:load={()=>{iconLoaded =true}}
            />
      
      </div>
        <div class="android-header">
          <h2 id="android-title" style="color:#3a3a3a">{@html userapp.title}</h2>
          <p id="android-by">{@html userapp.user}</p>
      </div>
     
      </div>
       <div
        class="android-description-head">
      {#if install}
          <a
            id="install-android"
            class="android-button"
            href="https://igappsfiles.blob.core.windows.net/apps/android/{userapp.appid}.apk"
            >
            {labels.android.install}
          </a>
        {:else}
          <a
            id="open-chrome"
            class="android-button"
            href="intent://154805.igen.app/#Intent;scheme=https;package=com.android.chrome;end">
            {labels.android.openchrome}
          </a>
        {/if}
      </div>
    
      <div class="android-description">
        <h4>{labels.android.about}</h4>
        <p id="android-desc">
          {@html userapp.desc}
        </p>
      </div>
    <div class="cats">
        <span id="android-cat">{@html userapp.cat}</span>
    </div>
    </div>
  </div>

<!-- {#if showModal}
  <Modal {lang} {samsungBrowser}/>
{/if} -->

<style>
    #a2handroid {
        background-color: #fff;
        color: #000;
        min-height: 100%;
    }

  #icon-container{
        display: inline-block;
        border-radius: 8px;
        margin:25px;
        padding:0;
        height: 72px;
        width: 72px;
        border: 1px solid rgba(180, 180, 180, 0.5);
  }
    #iconimg {
        border-radius: 8px;
        margin:0;
        height: 72px;
        width: 72px;
    }

    #open-chrome {
        display: none;
    }

    .android-header {
         position: absolute;
          left:120px;
          top:10px;
          width:calc(100% - 170px)
    }

        .android-header h2 {
          
            font-size: 1.4em;
            font-weight: 500;
            overflow: hidden;
            width:100%;
            
        }

        .android-header p {
            margin-top: -15px;
            margin-bottom: 15px;
            font-weight: 500;
            word-break: break-word;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;
            color:#3F835B;
        }
  .cats{
    display:block;
  height:60px;
  margin:25px;
  }
        #android-cat {
            border: 1px solid #ddd;
            border-radius: 24px;
            padding: 10px 16px;
            margin: 0;
            color: #595959;
            font-size: 0.9em;
            max-width: 200px;

        }

    .android-description-head {
        padding: 10px;
        text-align:center;
        margin-top: 10px;
    }

    .android-description h4{
        font-size:1.1em;
        font-weight:500;
    }

    .android-description {
        padding: 0px 25px;
    }
        .android-description p {
            font-weight: normal;
            text-align: left;
            font-size: 0.9em;
            line-height: 1.2em;
            color: rgb(89,89,89);
        }

    
    .android-button {
        display: block;
        width:calc(100% - 50px);
        max-width: 375px;
        font-size: 0.9em;
        margin:auto;
        margin-top: 40px;
        background-color: #3F835B;
        color: #fff;
        padding:10px;
        border-radius: 3px;
        font-weight: 500;
        text-decoration:none;
        user-select:none;
    }
</style>